module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iY29udGVudCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTQ0IDE0NCI+CiAgICA8Y2lyY2xlIGN4PSI3MiIgY3k9IjcyIiByPSI3MiIgZmlsbD0iIzI5NzlmZiIvPgogICAgPGNpcmNsZSBjeD0iNzIiIGN5PSI3MiIgcj0iNDgiIGZpbGw9IiM0MGM0ZmYiLz4KICAgIDxjaXJjbGUgY3g9IjcyIiBjeT0iNzIiIHI9IjI0IiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 194
// module chunks = 0